import * as React from 'react';
import { observer } from 'mobx-react';
import { NotTranslated } from '@execonline-inc/translations';

const Divider: React.FC = () => (
  <>
    &nbsp;&nbsp;
    <NotTranslated text="|" />
    &nbsp;&nbsp;
  </>
);

export default observer(Divider);
